export const extractInvoiceMonthsIDs = (data) => {
  const months = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  const invoiceMonthSet = new Set();

  for (const yearEntry of data) {
    for (const item of yearEntry.data) {
      for (const month of months) {
        const monthData = item[month];
        if (monthData && monthData.invoiceMonth) {
          invoiceMonthSet.add(monthData.invoiceMonth);
        }
      }
    }
  }

  return Array.from(invoiceMonthSet);
}


export const MonthNumberInvoiceMonths = (key) =>{

const month = {
enero:"01",
febrero:"02",
marzo:"03",
abril:"04",
mayo:"05",
junio:"06",
julio:"07",
agosto:"08",
septiembre:"09",
octubre:"10",
noviembre:"11",
diciembre:"12"
}

return month[key]
}